<template>
  <PaOverlayModal
   :appendClass="['pa-overlay-modal-default-transition-upper', 'pa-user-email-notification-regist-alert-modal']"
   :additionalZIndex="3"
   :isOpen="isOpenModal"
   :position="{top: .1}"
   :isFreez="true"
   :couldOverlaySwipeClose="false"
   contentTransitionName="trans-content"

   @afterEnterContent="handleAfterEnterContent"
   @afteredAfterEnterContent="handleAfterdEnterContent"
   @closeOverlayModal="handleCloseOverlay"
  >
    <div class="pa-wide-modal-box-wrapper pa-user-email-notification-regist-alert-modal-view">
      <div class="pa-wide-modal-box" ref="wideModalBox">
        <div class="pa-header">
          <div class="pa-title">メール通知設定の御報せ</div>
          <div class="pa-description">
            <p>異界舞踏会・アキバトリカルではメールにて更新情報等の御報せをお受け取り頂くことが可能です。メール通知を有効化されますと大変便利で御座います。</p>
          </div>
          <div class="pa-caption">
            <p>メール通知設定は事務所内の「外部通知設定」項目でいつでも設定の変更が可能で御座います。</p>
          </div>
        </div>

        <div class="pa-cancel">
          <button
          class="button pa-cancel-button"
          :disabled="isDisabledCancelButton"
          @click.prevent="handleClickCancelButton"
          >キャンセルして閉じる</button>
        </div>

        <button
        class="button pa-confirm-button"
        :class="submitButtonClass"
        :disabled="isDisabledSubmitButton"
        @click.prevent="handleClickSubmitButton"
        >メール通知を有効化する</button>
      </div>
    </div>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'

import {GetUserMeta}  from '@/graphql/queries/User.graphql'

import {SetEmailNotificationStatus} from '@/graphql/mutations/User.graphql'

export default {
  components : {
    PaOverlayModal
  },

  data(){
    return {
      shouldOpenModal : false,
      isOpenModal     : false,
      userMeta        : null,
      isEnterdContent : false,

      isLoadingButton : false,

      isDisabledCancelButton    : false,

      submitButtonClass         : {
        'is-loading'  : false
      },

      isDisabledSubmitButton    : false,
    }
  },
  
  apollo : {
    userMetaList: {
      query: GetUserMeta
    }
  },

  computed : {
    isMountedLoginedViewPage(){
      return this.$store.state.layouts.isMountedLoginedViewPage;
    },
  },

  watch : {
    isLoadingButton(value){
      this.isDisabledCancelButton = value;
      this.submitButtonClass['is-loading'] = value;
      this.isDisabledSubmitButton = value;
    },

    isMountedLoginedViewPage(){
      this.checkCouldOpenModal();
    },

    userMetaList : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.userMeta = JSON.parse(data.data);
      },
      deep: true
    },

    userMeta    : {
      handler(data){
        if(typeof data === 'undefined') return;
        
        if(typeof data['notifications.shoudDisplayRegistEmailModal'] !== 'undefined'){
          this.shouldOpenModal = data['notifications.shoudDisplayRegistEmailModal'];
        }

        this.checkCouldOpenModal();
      },
      deep: true
    },
  },

  methods : {
    handleAfterEnterContent(){
      const actualHeight = window.innerHeight - ((window.innerHeight * .1) * 2);

      const boxHeight = this.$refs.wideModalBox.offsetHeight;
      
      if(boxHeight > actualHeight){
        this.$refs.wideModalBox.style.height = actualHeight + 'px';
      }
    },

    handleAfterdEnterContent(){
      this.isEnterdContent = true;
    },

    checkCouldOpenModal(){
      let couldOpenModal = false;

      if(this.userMeta !== null){
        couldOpenModal = this.shouldOpenModal;
      }

      this.isOpenModal = couldOpenModal;
    },

    handleCloseOverlay(){
      this.closeModal();
    },

    async closeModal(){
      this.isEnterdContent = false;
    },

    executeSetEmailNotificationStatus(isAllow = true){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : SetEmailNotificationStatus,
          variables : {
            isAllow  : isAllow
          }
        }).then(async ({data: {SetEmailNotificationStatus:{status}}}) => {
          resolve(status);
        }).catch(async (error) => {
          console.error(error);

          resolve(false);
        });
      });
    },

    async handleClickSubmitButton(){

      this.isLoadingButton = true;

      await this.UXWaiting(500);

      await this.executeSetEmailNotificationStatus(true);

      this.isLoadingButton = false;

      this.$store.dispatch({
        type        : 'flashMessage/updateFlashMessage',
        hasMessage  : true,
        message     : '&nbsp;メール通知を有効化致しました。',
        status      : 'primary',
        hasControl  : true,
        autoClose   : 5000
      }, {root:true});

      this.isOpenModal = false;
      this.closeModal();
    },

    async handleClickCancelButton(){
      this.isLoadingButton = true;

      await this.UXWaiting(500);

      await this.executeSetEmailNotificationStatus(false);

      this.isLoadingButton = false;

      this.isOpenModal = false;
      this.closeModal();
    }
  }
}
</script>

<style lang="scss">
.pa-user-email-notification-regist-alert-modal{
  .pa-user-email-notification-regist-alert-modal-view{
    .pa-wide-modal-box{
      overflow-y: scroll;

      .pa-content-field{
        margin:1rem 0;
      }

      .pa-confirm-button{
        margin-top:1rem;
      }
    }
  }
}
</style>